import { parseNumber } from '../../utils/number.utils';
import { TotalInfo } from '../total-info';

export const totalInfoBuilder = <T> (builder: (any) => T[]) => (json: any) => {
  return (json)
    ? new TotalInfo(
      parseNumber(json.totalItems),
      builder(json.items),
    )
    : null;
};




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/total-info.builder.ts